import type { AbilityDef } from "../../sim";

/**
 * «Невидимка»: ← ← ← (три касания назад) — 2,5 с сопернику не видно героя; бить его можно. Одно деление Ярости, секрет
 * до боя. Джон 04.11.2026, 23:00: «невидимка — три раза назад» — вместо ✕ + ○.
 */
export const VANISH: AbilityDef = {
  id: "vanish",
  name: "Невидимка",
  input: { gesture: ["B", "B", "B"] },
  pose: "vanish",
  startup: 6,
  active: 0,
  recovery: 16,
  cost: 1000,
  secret: true,
  actions: [{ frame: 5, type: "invisible", params: { frames: 150 } }],
  fx: { start: "smoke/puff" },
  sound: { start: "vanish" },
};
